export enum ConfidenceFilterType {
  Min = 'min',
  Max = 'max',
}

export const AI_PHOTO_VALIDATION_DEMO_VIDEO_ID = 'K203bZu4_CQ';
